import React, {Fragment} from 'react';
import css from './list-items.scss';
import {ListItemCheckbox} from "./list-item-checkbox";

export function ListItemsChecklist(props) {
  const items = props.items || [];
  return (
    <Fragment>
      <ul className={css.checkList}>
        { (items.length > 0) && items.map(item =>
          <li key={item.id}>
            <ListItemCheckbox item={item}></ListItemCheckbox>
          </li>
        ) }
      </ul>
    </Fragment>
  );
}
